import Vue from "vue";
import draggable from 'vuedraggable';
import VueContext from 'vue-context';
import { VueTreeList, Tree, TreeNode } from 'vue-tree-list-v2';
import AlphanumericEncoder from 'alphanumeric-encoder';
import { romanToArab, arabToRoman, isValidArab, isValidRoman } from 'roman-numbers';
const encoder = new AlphanumericEncoder()
import { v4 as uuidv4 } from 'uuid';
import treeviewMixin from '../mixins/TreeViewEditorMixin.js'

Vue.component("items-treeview-editor", {
    props: ["items", "hasFourItemColumns", "note", "showNew", "menuName", "modalId", "modalTitle"],
    components: {
        draggable,
        VueContext,
        VueTreeList
    },
    mixins: [treeviewMixin],
    data() {
        return {
            treeData: new Tree(this.items),
            currentNode: null,
            showFormModal: false,
            isEditing: false,
            isAdding: false,
            isAddingFromParent: false,
            hasMultipleColumns: this.hasFourItemColumns,
            parentNote: this.note,
            hasSelected: false,
            viewModel: {
                orientation: 'Above ',
                changeType: 'Added',
                id: crypto.randomUUID(),
                description: null,
                referenceNumber: 1,
                classificationSystem: null,
                detailsText: null,
                groupText: null,
                classText: null,
                subclassText: null,
                hasMultipleColumns: false
            }
        };
    },
    methods: {
        onClick: function (data) {
            this.currentNode = data;
            this.hasSelected = true;
        },
        addFromParent: function () {
            this.contextClick('Add', null, 'Above');
        },
        onContextOpen: function (event, data) {
            this.currentNode = data;
            this.hasSelected = true;
        },
        contextClick: function (event, data, orientation) {
            if (event == 'Add') {

                this.isAdding = true;
                this.isEditing = false;
                this.showFormModal = true;
                this.viewModel = {
                    addTreeNodeDisabled: true,
                    addLeafNodeDisabled: true,
                    editNodeDisabled: true,
                    delNodeDisabled: true,
                    isLeaf: false,
                    orientation: orientation,
                    changeType: 'Added',
                    id: crypto.randomUUID(),
                    description: null,
                    referenceNumber: null,
                    displayOrder: this.currentNode ? this.currentNode.displayOrder : 1,
                    classificationSystem: null,
                    detailsText: null,
                    groupText: null,
                    classText: null,
                    subclassText: null,
                    hasMultipleColumns: false,
                    pid: 0

                }
            } else if (event == 'Edit') {
                this.isAdding = false;
                this.isEditing = true;
                this.showFormModal = true;

                this.viewModel = Object.assign({}, this.currentNode);

                if (this.currentNode.changeType == 'Added') {
                    this.viewModel.updatedDescription = this.viewModel.description;
                    this.viewModel.updatedReferenceNumber = this.viewModel.referenceNumber;

                    this.viewModel.updatedClassificationSystem = this.currentNode.classificationSystem;
                    this.viewModel.updatedDetailsText = this.viewModel.detailsText;
                    this.viewModel.updatedGroupText = this.viewModel.groupText;
                    this.viewModel.updatedClassText = this.viewModel.classText;
                    this.viewModel.updatedSubclassText = this.viewModel.subclassText;

                } else {
                    this.viewModel.updatedDescription = this.currentNode.updatedDescription ? this.currentNode.updatedDescription : this.viewModel.description;
                    this.viewModel.updatedReferenceNumber = this.currentNode.updatedReferenceNumber ? this.currentNode.updatedReferenceNumber : this.viewModel.referenceNumber;
                    this.viewModel.updatedDefinesSymbol = this.currentNode.updatedDefinesSymbol ? this.currentNode.updatedDefinesSymbol : this.viewModel.definesSymbol;
                    this.viewModel.updatedClassificationSystem = this.currentNode.updatedClassificationSystem ? this.currentNode.updatedClassificationSystem : this.viewModel.classificationSystem;
                    this.viewModel.updatedDetailsText = this.currentNode.updatedDetailsText ? this.currentNode.updatedDetailsText : this.viewModel.detailsText;
                    this.viewModel.updatedGroupText = this.currentNode.updatedGroupText ? this.currentNode.updatedGroupText : this.viewModel.groupText;
                    this.viewModel.updatedClassText = this.currentNode.updatedClassText ? this.currentNode.updatedClassText : this.viewModel.classText;
                    this.viewModel.updatedSubclassText = this.currentNode.updatedSubclassText ? this.currentNode.updatedSubclassText : this.viewModel.subclassText;

                }
            } else {
                this.currentNode.isDeleted = this.currentNode.isDeleted ? false : true;
                this.currentNode.changeType = this.currentNode.changeType == 'Deleted' ? null : 'Deleted';
            }

        },
        update: function () {
            let dmp = new diff_match_patch();
            console.log('test save')
            console.log(this.currentNode)
            if (this.isEditing) {
                if (!this.currentNode.changeType || this.currentNode.changeType == 'Updated') {
                    this.currentNode.updatedDescription = this.viewModel.updatedDescription;

                    this.currentNode.updatedReferenceNumber = this.viewModel.updatedReferenceNumber;
                    this.currentNode.updatedClassificationSystem = this.viewModel.updatedClassificationSystem;
                    this.currentNode.updatedDetailsText = this.viewModel.updatedDetailsText;
                    this.currentNode.updatedGroupText = this.viewModel.updatedGroupText;
                    this.currentNode.updatedClassText = this.viewModel.updatedClassText;
                    this.currentNode.updatedSubclassText = this.viewModel.updatedSubclassText;
                    this.currentNode.changeType = 'Updated';
                    if (this.currentNode.updatedGroupText || this.currentNode.updatedClassText || this.currentNode.updatedSubclassText) {
                        this.hasMultipleColumns = true;
                    }

                    this.currentNode.displayReferenceNumber = this.prettyDiffReferenceNumber(this.currentNode.referenceNumber, this.currentNode.updatedReferenceNumber);
                    this.currentNode.displayDescription = this.prettyDiff(this.$options.filters.stripParagraphTags(this.currentNode.description), this.$options.filters.stripParagraphTags(this.currentNode.updatedDescription));
                    this.currentNode.displayDetailsText = this.prettyDiff(this.currentNode.detailsText, this.currentNode.updatedDetailsText);
                    this.currentNode.displayGroupText = this.prettyDiff(this.currentNode.groupText, this.currentNode.updatedGroupText);
                    this.currentNode.displayClassText = this.prettyDiff(this.currentNode.classText, this.currentNode.updatedClassText);
                    this.currentNode.displaySubclassText = this.prettyDiff(this.currentNode.subclassText, this.currentNode.updatedSubclassText);

                    this.currentNode.cleanDisplayReferenceNumber = this.currentNode.updatedReferenceNumber;
                    this.currentNode.cleanDisplayDescription = this.$options.filters.stripParagraphTags(this.currentNode.updatedDescription);
                    this.currentNode.cleanDisplayDetailsText = this.currentNode.updatedDetailsText;
                    this.currentNode.cleanDisplayGroupText = this.currentNode.updatedGroupText;
                    this.currentNode.cleanDisplayClassText = this.currentNode.updatedClassText;
                    this.currentNode.cleanDisplaySubclassText = this.currentNode.updatedSubclassText;

                } else {
                    this.currentNode.description = this.viewModel.updatedDescription;

                    this.currentNode.referenceNumber = this.viewModel.updatedReferenceNumber;
                    this.currentNode.classificationSystem = this.viewModel.updatedClassificationSystem;
                    this.currentNode.detailsText = this.viewModel.updatedDetailsText;
                    this.currentNode.groupText = this.viewModel.updatedGroupText;
                    this.currentNode.classText = this.viewModel.updatedClassText;
                    this.currentNode.usubclassText = this.viewModel.updatedSubclassText;
                    if (this.currentNode.groupText || this.currentNode.classText || this.currentNode.subclassText) {
                        this.hasMultipleColumns = true;
                    }

                    this.currentNode.displayReferenceNumber = this.prettyDiffReferenceNumber('', this.currentNode.referenceNumber);
                    this.currentNode.displayDescription = this.prettyDiff('', this.$options.filters.stripParagraphTags(this.currentNode.description));
                    this.currentNode.displayDetailsText = this.prettyDiff('', this.currentNode.detailsText);
                    this.currentNode.displayGroupText = this.prettyDiff('', this.currentNode.groupText);
                    this.currentNode.displayClassText = this.prettyDiff('', this.currentNode.classText);
                    this.currentNode.displaySubclassText = this.prettyDiff('', this.currentNode.subclassText);

                    this.currentNode.cleanDisplayReferenceNumber = this.currentNode.referenceNumber;
                    this.currentNode.cleanDisplayDescription = this.$options.filters.stripParagraphTags(this.currentNode.description);
                    this.currentNode.cleanDisplayDetailsText = this.currentNode.detailsText;
                    this.currentNode.cleanDisplayGroupText = this.currentNode.groupText;
                    this.currentNode.cleanDisplayClassText = this.currentNode.classText;
                    this.currentNode.cleanDisplaySubclassText = this.currentNode.subclassText;


                }
            } else {
                var newNoteItem = this.viewModel;
                newNoteItem.displayReferenceNumber = this.prettyDiffReferenceNumber('', this.viewModel.referenceNumber);
                newNoteItem.displayDescription = this.prettyDiff('', this.$options.filters.stripParagraphTags(this.viewModel.description));
                newNoteItem.displayDetailsText = this.prettyDiff('', this.viewModel.detailsText);
                newNoteItem.displayGroupText = this.prettyDiff('', this.viewModel.groupText);
                newNoteItem.displayClassText = this.prettyDiff('', this.viewModel.classText);
                newNoteItem.displaySubclassText = this.prettyDiff('', this.viewModel.subclassText);

                newNoteItem.cleanDisplayReferenceNumber = this.viewModel.referenceNumber;
                newNoteItem.cleanDisplayDescription = this.$options.filters.stripParagraphTags(this.viewModel.description);
                newNoteItem.cleanDisplayDetailsText = this.viewModel.detailsText;
                newNoteItem.cleanDisplayGroupText = this.viewModel.groupText;
                newNoteItem.cleanDisplayClassText = this.viewModel.classText;
                newNoteItem.cleanDisplaySubclassText = this.viewModel.subclassText;

                if (newNoteItem.groupText || newNoteItem.classText || newNoteItem.subclassText) {
                    this.hasMultipleColumns = true;
                }

                var node = new TreeNode(this.viewModel)
                if (this.viewModel.orientation == 'Above') {
                    if (this.currentNode) {
                        this.currentNode.parent.addChildren(node);
                        node.insertBefore(this.currentNode);
                    } else {
                        if (this.treeData.children) {
                            this.treeData.children = [];

                        }
                        this.treeData.addChildren(node);
                    }


                } else if (this.viewModel.orientation == 'Below') {

                    if (this.currentNode) {
                        this.currentNode.parent.addChildren(node);
                        node.insertAfter(this.currentNode);
                    } else {
                        this.treeData.children = [];
                        this.treeData.addChildren(node);
                    }

                } else if (this.viewModel.orientation == 'Child') {

                    if (!this.currentNode.children) this.currentNode.children = [];
                    this.currentNode.addChildren(node);
                }
            }

            this.showFormModal = false;
            this.updateParent();
        },

        updateParent: function () {
            if (!this.parentNote.changeType) {
                this.parentNote.changeType = 'Updated';

            }
            this.$emit("update:note", this.parentNote);
            
            this.$emit("update:items", this.getNewTree());

            this.$emit('triggerchanges');

        },
        getNewTree: function () {

            var out = this.flatten([], this.treeData.children);

            var newTree = out.map(function mapper(item) {
                var newItem = Object.assign({}, item);
                if (newItem.children) {
                    newItem.children = undefined;
                }
                if (newItem.changeType == 'Added' && item.id == 'X') {
                    newItem.id = 0;
                }
                newItem.parent = undefined;

                if (item.pid == 0) newItem.pid = null;
                if (item.pid) {
                    newItem.pid = item.pid.toString();
                }
                return newItem;
            })
            return newTree;
        },
        flatten: function (into, node) {
            if (node == null) return into;
            if (Array.isArray(node)) return node.reduce(this.flatten, into);
            into.push(node);
            return this.flatten(into, node.children);
        },
        rearrange: function (type) {
            let dmp = new diff_match_patch();
            var pos = this.currentNode.parent.findChildIndex(this.currentNode);
            var items = this.currentNode.parent.children.slice(pos);
            items.map((x, i) => {
                var index = i + 1;

                if ((typeof x.changeType === 'undefined' || x.changeType == null) || x.changeType == 'Updated') {
                    x.updatedReferenceNumber = this.getParentReferenceNumber(this.currentNode.parent, this.referenceNumberFormatter(type, index), true);

                } else if (x.changeType == 'Added') {
                    x.referenceNumber = this.getParentReferenceNumber(this.currentNode.parent, this.referenceNumberFormatter(type, index), true);

                }


                var diffRef;

                if ((typeof x.changeType === 'undefined' || x.changeType == null) || x.changeType == 'Updated') {

                    diffRef = this.prettyDiffReferenceNumber(x.referenceNumber, x.updatedReferenceNumber);
                } else if (x.changeType == 'Added') {

                    diffRef = this.prettyDiffReferenceNumber('', x.referenceNumber);

                }
                if (diffRef) {
                    x.referenceNumberDisplayName = diffRef;

                }

                if (x.updatedReferenceNumber != x.referenceNumber) {
                    if ((typeof x.changeType === 'undefined' || x.changeType == null) || x.changeType == 'Updated') {
                        x.changeType = 'Updated';

                    }
                }

                return x;
            });

            var map = this.currentNode.parent.children.filter((x => x.displayOrder)).map(d => d.displayOrder);
            var minDisplayOrder = Math.min(...map);
            this.currentNode.parent.children.map((x, i) => {
                x.displayOrder = minDisplayOrder;
                minDisplayOrder += 1;
                if ((typeof x.changeType === 'undefined' || x.changeType == null) || x.changeType == 'Updated') {
                    x.changeType = 'Updated';
                    if (typeof x.updatedDescription === 'undefined' || !x.updatedDescription) {
                        x.updatedDescription = x.name;
                    }
                    if (typeof x.updatedDetailsText === 'undefined' || !x.updatedDetailsText) {
                        x.updatedDetailsText = x.detailsText;
                    }
                    if (typeof x.updatedGroupText === 'undefined' || !x.updatedGroupText) {
                        x.updatedGroupText = x.groupText;
                    }

                    if (typeof x.updatedClassText === 'undefined' || !x.updatedClassText) {
                        x.updatedClassText = x.classText;
                    }
                    if (typeof x.updatedSubclassText === 'undefined' || !x.updatedSubclassText) {
                        x.updatedSubclassText = x.subclassText;
                    }


                }
                return x;
            })

            this.updateParent();


        },

        onDrag: function (dragged) {
            this.treeData.map((item, index) => {
                item.displayOrder = index + 1;
                if (!item.changeType || item.changeType == 'Updated') {
                    item.changeType = 'Updated';
                }
                return
            })

            console.log(this.treeData);
        },
        drop: function (node) {

            node.node.isDragged = true;
            node.node.changeType = 'Updated';
            this.$nextTick();

            this.updateParent();

        },
        dropBefore: function (node) {



        },
        dropAfter: function (node) {
        },
    },
    computed: {
        hasDeleted() {
            var out = this.flatten([], this.treeData.children);
            var val = out.some((x => x.changeType === 'Deleted'));
            return val;

        },
        hasItems() {
            return this.treeData.children && this.treeData.children.length > 0;
        },
        classificationSystem: function () {
            if (this.note.updatedClassificationSystem) {
                return this.note.updatedClassificationSystem
            } else {
                return this.note.classificationSystem

            }
        },
        //descriptionLabel: function () {
        //    return window.labels.description;
        //},
        //groupLabel: function () {
        //    return window.labels.group;
        //},
        //classLabel: function () {
        //    return window.labels.class;
        //},
        //subclassLabel: function () {
        //    return window.labels.subclass;
        //},
        //detailsLabel: function () {
        //    return window.labels.codeText;
        //},
        //aboveLabel: function () {
        //    return window.labels.above;
        //},
        //belowLabel: function () {
        //    return window.labels.below;
        //},
        //childLabel: function () {
        //    return window.labels.child;
        //},
        //editLabel: function () {
        //    return window.labels.edit;
        //},
        //deleteLabel: function () {
        //    return window.labels.delete;
        //},
        //referenceNumberLabel: function () {
        //    return window.labels.referenceNumber;
        //},
        //nameLabel: function () {
        //    return window.labels.name;
        //},
        //multipleColumnsLabel: function () {
        //    return window.labels.multipleColumns;
        //},
        //exclusionLabel: function () {
        //    return window.labels.exclusion;
        //},
        //saveLabel: function () {
        //    return window.labels.save;
        //},
        //cancelLabel: function () {
        //    return window.labels.cancel;
        //},
        //addLabel: function () { return window.labels.add; },
        //arrangeNumberingLabel: function () { return window.labels.arrangeNumbering; },
        //arabLabel: function () { return window.labels.arab; },
        //alphaUpperLabel: function () { return window.labels.alphabetUpper; },
        //alphaLowerLabel: function () { return window.labels.alphabetLower; },
        //romanUpperLabel: function () { return window.labels.romanUpper; },

        //romanLowerLabel: function () { return window.labels.romanLower; },
        //numberingTooltip: function () { return window.labels.numberingTooltip },
        //entitySuffixSymbolLabel: function () { return window.labels.entitySuffixSymbol },
        //entityDefineSuffixLabel: function () { return window.labels.entityDefineSuffix },
       
        //noteDetails: function () { return window.labels.noteDetails },
        //noteText: function () { return window.labels.noteText },
        //noteTextTooltip: function () { return window.labels.noteTextTooltip },

        //exclusionLabel: function () { return window.labels.exclusionLabel },
        //exclusionTooltip: function () { return window.labels.exclusionTooltip },

        //classificationSystemTooltip: function () { return window.labels.classificationSystemTooltip },

        //referenceNumberingTooltip: function () { return window.labels.referenceNumberingTooltip },
        //entityNameTooltip: function () { return window.labels.entityNameTooltip },
        //entityOriginalNameTooltip: function () { return window.labels.entityOriginalNameTooltip },
        //entitySuffixSymbolTooltip: function () { return window.labels.entitySuffixSymbolTooltip },
        //entityDefineSuffixTooltip: function () { return window.labels.entityDefineSuffixTooltip },
        //addNewEntryTooltip: function () { return window.labels.coverageAddNewEntryTooltip },
        //footnoteDetails: function () { return window.labels.coverageFootnoteDetails },
        //addGoodsItem: function () { return window.labels.coverageAddGoodsItem },
        //addServicesItem: function () { return window.labels.coverageAddServicesItem },
        //addConstructionItem: function () { return window.labels.coverageAddConstructionServicesItem },
        //coverageDescription: function () { return window.labels.coverageDescription },
        //coverageDescriptionTooltip: function () { return window.labels.coverageDescriptionTooltip }, 

    },
    template: `
	<div class="columns mt-0 "  >
		<div class="column">
			<div class="columns" v-if="hasItems">
				<div class="column">
					<div class="buttons has-addons">
						<b-field class="">
							<b-dropdown aria-role="list" :disabled="!hasSelected">
								<template #trigger="{ active }">
									<b-button
										size="is-small"
										:label="addLabel"
										icon-left="plus" />
								</template>
								<b-dropdown-item aria-role="listitem" @click="contextClick('Add', null, 'Above')">{{aboveLabel}}</b-dropdown-item>
								<b-dropdown-item aria-role="listitem" @click="contextClick('Add', null, 'Below')">{{belowLabel}}</b-dropdown-item>
								<b-dropdown-item aria-role="listitem" @click="contextClick('Add', null, 'Child')">{{childLabel}}</b-dropdown-item>

							</b-dropdown>
							<b-button size="is-small"
								icon-left="minus"  @click="contextClick('Edit', null)" :disabled="!hasSelected">
									{{ editLabel }}
							</b-button>
							<b-button size="is-small"
								icon-left="trash-alt" @click="contextClick('Delete')"  :disabled="!hasSelected">
									{{ deleteLabel }}
							</b-button>
							 <b-dropdown aria-role="list" :disabled="!hasSelected">
								<template #trigger="{ active }">
									<b-button
										size="is-small"
										:label="arrangeNumberingLabel"
										icon-left="arrow-down-short-wide" />
								</template>
								<b-dropdown-item aria-role="listitem" @click="rearrange('arab')">{{ arabLabel }}</b-dropdown-item>
								<b-dropdown-item aria-role="listitem" @click="rearrange('alphaupper')">{{ alphaUpperLabel }}</b-dropdown-item>
								<b-dropdown-item aria-role="listitem" @click="rearrange('alphalower')">{{ alphaLowerLabel }}</b-dropdown-item>
								<b-dropdown-item aria-role="listitem" @click="rearrange('romanupper')">{{ romanUpperLabel }}</b-dropdown-item>
								<b-dropdown-item aria-role="listitem" @click="rearrange('romanlower')">{{ romanLowerLabel }}</b-dropdown-item>
							</b-dropdown>
						</b-field>
					</div>
				</div>
			</div>
           <div class="columns m-0 has-text-weight-bold has-border-bottom" v-if="hasItems" >
              <span class="is-inline-flex">
                <span class="icon-text">
                     <span class="icon">
                                <i class="fa fa-fw"></i>
                            </span>
                </span>

              </span>
                                    <div class="column is-1 p-0">
						               
                                    </div>
                                    <div class="column p-0">
						               {{ descriptionLabel }}
                                    </div>
                                     <div class="column  p-0" v-if="hasFourItemColumns">
						      			{{groupLabel }}
                                    </div>
                                     <div class="column  p-0" v-if="hasFourItemColumns">
						        	   {{ classLabel }}
                                    </div>
                                     <div class="column  p-0" v-if="hasFourItemColumns">
						               {{ subclassLabel }}
                                    </div>
                                     <div class="column p-0 is-1" >
						               {{ classificationSystem }}
                                    </div>
                                        <span class="icon-text">
                                             <span class="icon">
                                                <i class="fa fa-fw"></i>
                                             </span>
                                        </span>
                       
                                </div>
                            
			<vue-tree-list
				:model="treeData"
				v-bind:default-expanded="true"
                @drop="drop"
                @drop-after="dropAfter"
                @drop-before="dropBefore"
			>
				<template v-slot:leafNameDisplay="props">
					
                        <div class="columns m-0" @click.prevent="onClick(props.model)" @contextmenu.prevent="$refs[menuName].open($event, props.model)" 
                        >
                            <div class="column is-full p-0">
                                 <div class="columns  m-0" :class=" { 
                            'has-background-info-light': currentNode != null && currentNode.id == props.model.id, 
                            'has-linethrough': props.model.changeType == 'Deleted', 
                            'has-background-success-light': props.model.isDragged
                        }">
                                    <div class="column is-1  p-0">
						                <div class="entity-row-reference-number pr-2 pl-1" v-if="!showNew" v-html="props.model.displayReferenceNumber"></div>
						                <div class="entity-row-reference-number pr-2 pl-1" v-if="showNew"  v-html="props.model.cleanDisplayReferenceNumber"></div>

                                    </div>
                                    <div class="column p-0">
						                <div class="entity-row-reference-number pr-2 pl-1"  v-if="!showNew" v-html="$options.filters.decodeHTMLEntity($options.filters.stripParagraphTags(props.model.displayDescription))"></div>
						                <div class="entity-row-reference-number pr-2 pl-1"  v-if="showNew" v-html="$options.filters.decodeHTMLEntity($options.filters.stripParagraphTags(props.model.cleanDisplayDescription))"></div>

                                    </div>
                                     <div class="column  p-0" v-if="hasFourItemColumns">
						      						        <div class="entity-row-display-name"  v-if="!showNew" v-html="props.model.displayGroupText"></div>
						      						        <div class="entity-row-display-name"  v-if="showNew" v-html="props.model.cleanDisplayGroupText"></div>

                                    </div>
                                     <div class="column  p-0" v-if="hasFourItemColumns">
						        	        <div class="entity-row-display-name" v-if="!showNew"  v-html="props.model.displayClassText"></div>
						        	        <div class="entity-row-display-name" v-if="showNew"  v-html="props.model.cleanDisplayClassText"></div>
						
                                    </div>
                                     <div class="column  p-0" v-if="hasFourItemColumns">
						                <div class="entity-row-display-name" v-if="!showNew" v-html="props.model.displaySubclassText"></div>
						                <div class="entity-row-display-name" v-if="showNew" v-html="props.model.cleanDisplaySubclassText"></div>
					
                                    </div>
                                     <div class="column p-0 is-1">
						                <div class="entity-row-display-name"  v-if="!showNew"  v-html="props.model.displayDetailsText"></div>
						                <div class="entity-row-display-name"  v-if="showNew"  v-html="props.model.cleanDisplayDetailsText"></div>
						
                                    </div>
                                      <span class="icon-text" v-if="props.model.changeType == 'Deleted'">
                                        <span class="icon">
                                            <i class="fa fa-trash"></i>
                                        </span>
                                    </span>
                                     <span class="icon-text" v-if="props.model.changeType == 'Added'">
                                        <span class="icon">
                                            <i class="fa fa-plus"></i>
                                        </span>
                                    </span>
                                       <span class="icon-text" v-if="!props.model.changeType || props.model.changeType == 'Updated'">
                                        <span class="icon">
                                            <i class="fa fa-fw"></i>
                                        </span>
                                    </span>
                                </div>
                            </div>

                        </div>
                       
						
							
                      
                   
				</template>
				<template v-slot:treeNodeIcon="props" class="is-inline-flex">
                    <span class="is-inline-flex">
                   
                   
                        <span class="icon-text" v-if="props.model.excluded">
                            <span class="icon">
                                <i class="fa fa-times-circle"></i>
                            </span>
                        </span>
                        <span class="icon-text" v-if="!props.model.excluded">
                            <span class="icon">
                                <i class="fa fa-fw"></i>
                            </span>
                        </span>
                    </span>
				</template>
              
			</vue-tree-list>
			<vue-context :ref="menuName" v-slot="{ data }" @open="onContextOpen">
				<li class="v-context__sub">
					<a href="#" >{{ addLabel }}</a>
					<ul class="v-context">
						<li>
							<a @click.prevent="contextClick('Add', data, 'Above')">{{ aboveLabel }}</a>
						</li>
						<li>
							<a @click.prevent="contextClick('Add', data, 'Below')">{{ belowLabel }}</a>
						</li>
		<li>
							<a @click.prevent="contextClick('Add', data, 'Child')">{{ childLabel }}</a>
						</li>
		
					</ul>
				</li>
				<li>
					<a href="#" @click.prevent="contextClick('Edit', data)">{{ editLabel }}</a>
				</li>
				<li>
					<a href="#" @click.prevent="contextClick('Delete', data)">{{ deleteLabel }}</a>
				</li>
			</vue-context>
			<b-modal :id="modalId" width="900px" parent="coverageModal" :ref="modalId" v-model="showFormModal" #default="props" :can-cancel="['x']">
				<div class="modal-card" style="width: auto">
					<header class="modal-card-head">
						<p class="modal-card-title">
						        {{ modalTitle }}
						</p>
					</header>
					<section class="modal-card-body">
						<div class="columns">
							<div class="column is-one-third">
								   <b-field >
                                    <template #label>
                                                <span>{{ referenceNumberingLabel }}</span>
                                                <b-tooltip class="custom" type="is-success" position="is-top" multilined append-to-body>
                                                    <template v-slot:content>
                                                        {{ referenceNumberingTooltip }}
                                                    </template>
                                                    <b-icon size="is-small" icon="circle-question"></b-icon>
                                                </b-tooltip>
                                            </template>
										<b-input v-if="!isEditing" v-model="viewModel.referenceNumber"></b-input>
										<b-input v-else v-model="viewModel.updatedReferenceNumber"></b-input>

								   </b-field>
							</div>
							
							
						</div>
                        <div class="columns">
                            <div class="column">
								   <b-field :label="nameLabel">
                                        <template #label>
                                            <span>{{ coverageDescription }}</span>
                                            <b-tooltip class="custom" type="is-success" position="is-top" multilined append-to-body>
                                                <template v-slot:content>
                                                    {{ coverageDescriptionTooltip }}
                                                </template>
                                                <b-icon size="is-small" icon="circle-question"></b-icon>
                                            </b-tooltip>
                                        </template>
										<wto-ck-editor  v-if="!isEditing" :view-model-data.sync="viewModel.description"></wto-ck-editor>
										<wto-ck-editor  v-else :view-model-data.sync="viewModel.updatedDescription"></wto-ck-editor>

								   </b-field>
							</div>
                        </div>
                        <div class="columns">
                           <div class="column is-one-third">
								   <b-field>
										 <b-checkbox v-model="viewModel.hasMultipleColumns"> {{ multipleColumnsLabel }}
                                                <b-tooltip class="custom" type="is-success" position="is-top" multilined append-to-body>
                                                        <template v-slot:content>
                                                            {{ multipleColumnTooltip }}
                                                        </template>
                                                        <b-icon size="is-small" icon="circle-question"></b-icon>
                                                </b-tooltip>
                                         </b-checkbox>
								   </b-field>
							</div>
                              <div class="column is-one-third">
								   <b-field>
										  <b-checkbox v-model="viewModel.excluded"> {{ exclusionLabel }}
                                            <b-tooltip class="custom" type="is-success" position="is-top" multilined append-to-body>
                                                    <template v-slot:content>
                                                        {{ exclusionTooltip }}
                                                    </template>
                                                    <b-icon size="is-small" icon="circle-question"></b-icon>
                                            </b-tooltip>
                                         </b-checkbox>
								   </b-field>
							</div>
                        </div>
						  <div class="columns" >
						
							<div class="column">
								   <b-field :label="detailsLabel">
										<b-input v-if="!isEditing" v-model="viewModel.detailsText"></b-input>
										<b-input v-else v-model="viewModel.updatedDetailsText"></b-input>
								   </b-field>
							</div>
							<div class="column" v-if="viewModel.hasMultipleColumns">
								   <b-field :label="groupLabel">
										<b-input v-if="!isEditing" v-model="viewModel.groupText"></b-input>
										<b-input v-else v-model="viewModel.updatedGroupText"></b-input>
								   </b-field>
							</div>
							<div class="column"  v-if="viewModel.hasMultipleColumns">
								   <b-field :label="classLabel">
										<b-input v-if="!isEditing" v-model="viewModel.classText"></b-input>
										<b-input v-else v-model="viewModel.updatedClassText"></b-input>
								   </b-field>
							</div>
							<div class="column"  v-if="viewModel.hasMultipleColumns">
								   <b-field :label="subclassLabel">
										<b-input v-if="!isEditing" v-model="viewModel.subclassText"></b-input>
										<b-input v-else v-model="viewModel.updatedSubclassText"></b-input>
								   </b-field>
							</div>
						</div>
					</section>
					<footer class="modal-card-foot buttons is-right">
						<b-button :label="saveLabel" @click="update"></b-button>
						<b-button :label="cancelLabel" @click="props.close"></b-button>

					</footer>
				 </div>
			</b-modal>
		</div>
	</div>
	`
});